import firebase from "datastore/database";
import store from "datastore/store";

function chunkArray(arr, size) {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
}

export default function observeBusinessGroupUsers(groupBuid) {
  if (!groupBuid) return;
  store.dispatch({ type: "ADD_BUSINESS_GROUP_USERS_LOADING" });

  let userUnsubscribers = [];

  let chunkResults = [];

  firebase
    .firestore()
    .doc(`business-groups/${groupBuid}`)
    .onSnapshot(
      (docSnapshot) => {
        const groupData = docSnapshot.data();
        const groupUids = groupData?.uids || [];

        userUnsubscribers.forEach((unsub) => unsub());
        userUnsubscribers = [];
        chunkResults = [];

        const chunks = chunkArray(groupUids, 10);

        chunks.forEach((chunk, index) => {
          chunkResults[index] = {};
          firebase
            .firestore()
            .collection("users")
            .where("businessUids", "array-contains-any", chunk)
            .onSnapshot(
              (querySnapshot) => {
                const result = {};
                querySnapshot.forEach((userDoc) => {
                  const data = userDoc.data();
                  const branches = data.branches || [];
                  if (branches && branches.length) {
                    result[userDoc.id] = data;
                  }
                });

                chunkResults[index] = result;

                const combinedUsers = Object.assign({}, ...chunkResults);
                store.dispatch({
                  type: "ADD_BUSINESS_GROUP_USERS_SUCCESS",
                  groupUsers: combinedUsers,
                });
              },
              (error) => {
                store.dispatch({
                  type: "ADD_BUSINESS_GROUP_USERS_ERROR",
                  error,
                });
              }
            );
        });
      },
      (error) => {
        store.dispatch({ type: "ADD_BUSINESS_GROUP_USERS_ERROR", error });
      }
    );
}
